import { render, staticRenderFns } from "./IconSettingAlerts.vue?vue&type=template&id=79eab166&"
import script from "./IconSettingAlerts.vue?vue&type=script&lang=ts&"
export * from "./IconSettingAlerts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports